import Form1 from './Form_1'

export default {
  Form_1: Form1
}
